export enum CouponFrequencies {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    SemiAnnual = 'Semi-Annual',
    Annually = 'Annually',
    Weekly = 'Weekly'
}